export default {
  "route": {
    "title": "सूचना प्रकाशन प्रणाली",
    "home": "होम",
    "terminal": "टर्मिनल",
    "program": "प्रोग्राम",
    "h5program": "प्रोग्राम",
    "my": "मेरा",
    "remote_control": "रिमोट कंट्रोल",
    "task_details": "कार्य विवरण",
    "add_task": "कार्य जोड़ें",
    "program_list": "कार्यक्रम सूची",
    "terminal_info": "टर्मिनल जानकारी",
    "add_resolution": "रिज़ॉल्यूशन जोड़ें",
    "add_program": "कार्यक्रम जोड़ें",
    "material_management": "सामग्री प्रबंधन",
    "create_program": "कार्यक्रम बनाएं",
    "login": "लॉगिन",
    "reset_password": "पासवर्ड रीसेट",
    "change_password": "पासवर्ड बदलें",
    "preview": "पूर्वावलोकन"
  },
  append_field:{
    "input_code": "कृपया सत्यापन कोड दर्ज करें",
    "code_error": "सत्यापन कोड त्रुटि",
    "fill_code": "कृपया सत्यापन कोड दर्ज करें",
    "dOut": "3D घुमाव बाहर",
    "dIn": "3D घुमाव अंदर",
    "dxiao": "3D चित्र प्रभाव",
    "selectImage": "कृपया चित्र चुनें",
    "onlySelectOneImage": "केवल एक चित्र चुन सकते हैं",
    "imageFormatError": "चित्र प्रारूप त्रुटि",
    "cancel": "रद्द करें",
    "selectedNumber": "चयनित",
    "confirm": "पुष्टि करें",
    "loadinga": "लोड हो रहा है...",
    "loadingb": "लोड हो रहा है",
    "uploading": "अपलोड हो रहा है",
    "selectStartDates": "प्रारंभ तिथि चुनें",
    "selectEndDates": "समाप्ति तिथि चुनें",
    "createTask": "नया कार्य बनाएं",
    "selectPrograms": "कार्यक्रम चुनें",
    "createPrograms": "प्रोग्राम बनाएँ",
    "editTask": "कार्य संपादित करें",
    "fillTaskName": "कृपया नाम दर्ज करें",
    "selectTaskGroup": "कृपया कार्य समूह चुनें",
    "selectProgram": "कृपया कार्यक्रम चुनें",
    "selected": "चयनित",
    "programs": "कार्यक्रम",
    "selectDevice": "कृपया उपकरण चुनें",
    "sendTaskSuccess": "कार्य सफलतापूर्वक भेजा गया",
    "taskName": "नाम",
    "playMode": "प्ले मोड",
    "replaceMode": "मोड बदलें",
    "appendMode": "मोड जोड़ें",
    'apotpatterns': 'मोड डालें',
    "dateRange": "प्ले की तिथि",
    "timeRange": "प्ले का समय",
    "taskPeriod": "निर्दिष्ट सप्ताह",
    "mon": "सोम",
    "tue": "मंगल",
    "wed": "बुध",
    "thu": "गुरु",
    "fri": "शुक्र",
    "sat": "शनि",
    "sun": "रवि",
    "back": "वापस",
    "programList": "कार्यक्रम सूची",
    "deviceList": "उपकरण सूची",
    "enterContent": "कृपया सामग्री दर्ज करें",
    "taskGroup": "कार्य समूह",
    "selectStartDate": "कृपया प्रारंभ तिथि चुनें",
    "selectEndDate": "कृपया समाप्ति तिथि चुनें",
    "selectStartTime": "कृपया प्रारंभ समय चुनें",
    "selectEndTime": "कृपया समाप्ति समय चुनें",
    "addTask": "कार्य जोड़ें",
    "topLeft": "ऊपरी बायां",
    "topCenter": "ऊपर का केंद्र",
    "topRight": "ऊपरी दायां",
    "leftCenter": "बाएं केंद्र",
    "center": "केंद्र",
    "rightCenter": "दाएं केंद्र",
    "bottomLeft": "निचला बायां",
    "bottomCenter": "नीचे का केंद्र",
    "bottomRight": "निचला दायां",
    "enterText": "कृपया पाठ दर्ज करें",
    "fontColor": "फ़ॉन्ट का रंग",
    "bgColor": "पृष्ठभूमि का रंग",
    "scrollDirection": "स्क्रॉल दिशा",
    "scrollSpeed": "स्क्रॉल गति",
    "fontSize": "फ़ॉन्ट का आकार",
    "alignment": "संरेखण",
    "subtitle": "उपशीर्षक",
    "enterURL": "कृपया URL दर्ज करें",
    "webPage": "वेब",
    "enterMediaURL": "कृपया स्ट्रीमिंग पता दर्ज करें",
    "media": "स्ट्रीमिंग मीडिया",
    "selectVideo": "कृपया वीडियो चुनें",
    unsupportedFormat: 'असमर्थित फ़ाइल प्रारूप। विस्तृत समर्थित प्रारूपों के लिए कृपया मेरे - सिस्टम सहायता में देखें।',
    "cancelAllSelections": "नए फ़ाइल अपलोड करने से पहले कृपया सभी चयनित सामग्री को रद्द करें",
    "fileName": "फ़ाइल नाम",
    "fileSize": "फ़ाइल आकार",
    "uploadProgress": "अपलोड प्रगति",
    "cancelUpload": "अपलोड रद्द करें",
    "cancelAllUploads": "सभी अपलोड रद्द करें",
    "leftToRights": "बाएं से दाएं",
    "rightToLefts": "दाएं से बाएं",
    "bottomToTops": "नीचे से ऊपर",
    "static": "स्थिर",
    "slow": "धीमा",
    "medium": "मध्यम",
    "fast": "तेज़",
    "colorValue": "रंग मान",
    "defaultEffect": "डिफ़ॉल्ट प्रभाव",
    "rightToLeft": "दाएं से बाएं",
    "leftToRight": "बाएं से दाएं",
    "topToBottom": "ऊपर से नीचे",
    "bottomToTop": "नीचे से ऊपर",
    "accordionSqueeze": "अकॉर्डियन संपीड़न",
    "zoomInFade": "ज़ूम इन फेड",
    "zoomOutFade": "ज़ूम आउट फेड",
    "depthOfField": "गहराई का प्रभाव",
    "leftRightRotate": "बाएं-दाएं घुमाव",
    "upDownRotate": "ऊपर-नीचे घुमाव",
    "counterclockwiseRotate": "विपरीत दिशा में घुमाव",
    "clockwiseRotate": "घड़ी की दिशा में घुमाना",
    "upDownZoom": "ऊपर-नीचे ज़ूम",
    "scaleFade": "स्केल फेड",
    "zoomInDisappearing": "ज़ूम इन गायब होने वाली एनीमेशन",
    "transparentFade": "पारदर्शी फेड",
    "gradientScale": "ग्रेडिएंट स्केल",
    "deleteMaterial": "सामग्री हटाएँ",
    "confirmDeleteMaterial": "क्या आप इस सामग्री को हटाना चाहते हैं?",
    "unreviewed": "अवलोकित नहीं",
    "normal2": "सामान्य",
    "violating": "उल्लंघन",
    "suspectedViolating": "संभावित उल्लंघन",
    "delete": "हटाएँ",
    "selectMaterial": "कृपया सामग्री चुनें",
    "deleteProgramGroup": "कार्यक्रम समूह हटाएँ",
    "confirmDeleteGroup": "क्या आप इस समूह को हटाना चाहते हैं?",
    "add": "जोड़ें",
    "toggle_effect": "कार्टून विशेष प्रभावं",
    "toggle_time": "समय टॉगल करें",
    "pub_toggle_time": "चित्र चलाने का समय ",
    "fullscreen": "पूर्ण स्क्रीन",
    "normal": "सामान्य",
    "interactive": "इंटरैक्टिव",
    "main_screen": "मुख्य स्क्रीन",
    "sub_screen": "उप स्क्रीन",
    "dual_screen": "डुअल स्क्रीन",
    "sync_task": "कार्य समन्वयित करें",
    "normal_mode": "सामान्य मोड",
    "basic_info": "बुनियादी जानकारी",
    "program_info": "कार्यक्रम जानकारी",
    "task_name": "कार्यक्रम का नाम",
    "task_type": "कार्य का प्रकार",
    "pub_task": "सामान्य कार्य",
    "hu_task": "इंटरैक्टिव कार्य",
    "no_data": "कोई डेटा नहीं",
    "no_msg": "कोई संदेश नहीं",
    "program_name": "प्रोग्राम का नाम",
    "program_resolution": "कार्यक्रम का संकल्प",
    "program_type": "कार्यक्रम का प्रकार",
    "screen_category": "स्क्रीन श्रेणी",
    "edit_program": "कार्यक्रम संपादित करें",
    "edit": "संपादित करें",
    "send": "भेजें",
    "create": "समूह बनाएं",
    "reload": "रीलोड करें",
    "name": "नाम",
    "create_task_z": "कार्य समूह बनाएं",
    "ps_push_name": "कृपया समूह का नाम दर्ज करें",
    "device_list": "डिवाइस सूची",
    "delete_task_group": "कार्य समूह हटाएँ",
    "confirm_delete_group": "क्या आप इस समूह को हटाना चाहते हैं?",
    "delete_success": "हटाना सफल",
    "name_cannot_be_empty": "नाम खाली नहीं हो सकता",
    "character_length_limit": "अक्षरों की लंबाई 10 के भीतर होनी चाहिए",
    "create_task_success": "कार्य बनाना सफल",
    "create_task_failed": "बनाना विफल",
    "confirm_delete_task": "क्या आप कार्य को हटाना चाहते हैं?",
    "task_details": "कार्य विवरण",
    "download_success": "डाउनलोड सफल",
    "waiting_download": "डाउनलोड की प्रतीक्षा कर रहे हैं",
    "downloading": "डाउनलोड हो रहा है",
    "confirm_delete": "क्या आप हटाना चाहते हैं?",
    "confirm_delete_all": "क्या आप सभी को हटाना चाहते हैं?",
    "confirm_delete_selected": "क्या आप चयनित को हटाना चाहते हैं?",
    "no_data_to_clear": "साफ करने के लिए कोई डेटा नहीं है!",
    "refresh": "ताज़ा करे",
    "clear_all": "सभी साफ करें",
    "clear_completed": "पूर्ण को साफ करें",
    "device_id": "डिवाइस आईडी",
    "task_size": "कार्य का आकार",
    "speed": "गति",
    "download_progress": "डाउनलोड प्रगति",
    "title": "शीर्षक",
    "volume": "ध्वनि",
    "deleteP": "कार्यक्रम हटाएँ",
    "con_P": "क्या आप इस कार्यक्रम को हटाना चाहते हैं?",
    "clear": "कैनवास साफ़ करेंं",
    "download_status": "डाउनलोड स्थिति",
    "height_width_cannot_be_empty": "ऊँचाई/चौड़ाई खाली नहीं हो सकती",
    "add_success": "जोड़ना सफल",
    "enter_number_between_300_to_8000": "300~8000 के बीच का नंबर दर्ज करें",
    "width": "चौड़ाई",
    "enter_width": "कृपया चौड़ाई दर्ज करें",
    "height": "ऊँचाई",
    "enter_height": "कृपया ऊँचाई दर्ज करें",
    "confirm_leave_page": "क्या आप इस पृष्ठ को छोड़ना चाहते हैं?",
    "add_content_to_control": "कंट्रोल में सामग्री जोड़ें",
    "add_control": "कंट्रोल जोड़ें",
    "save_success": "सहेजना सफल",
    "save": "सहेजें",
    "create_program": "कार्यक्रम बनाएं",
    "guess": "आपका अनुमान",
    "modify": "संशोधित करें",
    "text": "पाठ",
    "image": "चित्र",
    "background_image": "पृष्ठभूमि छवि",
    "background_music": "पृष्ठभूमि संगीत",
    "replace": "बदलें",
    "use_this_template": "इस टेम्पलेट का उपयोग करें",
    "apply_template": "टेम्पलेट लागू करें",
    "enter_program_name": "कृपया कार्यक्रम का नाम दर्ज करें",
    "program_group": "कार्यक्रम समूह",
    "select_program_group": "कृपया कार्यक्रम समूह चुनें",
    "group_list": "समूह सूची",
    "preview": "पूर्वावलोकन",
    "my_apps": "मेरे ऐप्स",
    "template_center": "टेम्पलेट केंद्र",
    "home": "मुख्य पृष्ठ",
    "source_of_visit": "आगमन स्रोत",
    "online": "ऑनलाइन",
    "terminal_status": "स्थिति",
    "memory_status": "मेमोरी स्थिति",
    "login": "लॉगिन",
    "sms_verification": "एसएमएस सत्यापन",
    "email_verification": "ईमेल सत्यापन",
    "log_in": "लॉग इन करें",
    "enter_username": "कृपया खाता दर्ज करें",
    "username_cannot_be_empty": "उपयोगकर्ता नाम खाली नहीं हो सकता",
    "password_cannot_be_empty": "पासवर्ड खाली नहीं हो सकता",
    "incorrect_phone_format_for_verification_code": "आपके द्वारा प्राप्त सत्यापन कोड का फोन नंबर प्रारूप गलत है, कृपया व्यवस्थापक से संपर्क करें!",
    "incorrect_email_format_for_verification_code": "आपके द्वारा प्राप्त सत्यापन कोड का ईमेल प्रारूप गलत है, कृपया व्यवस्थापक से संपर्क करें!",
    "incorrect_phone_or_email_format_for_verification_code": "आपके द्वारा प्राप्त सत्यापन कोड का ईमेल या फोन प्रारूप गलत है, कृपया व्यवस्थापक से संपर्क करें!",
    "reset_password": "पासवर्ड रीसेट करें",
    "remember_password": "पासवर्ड याद रखें",
    "register": "खाता पंजीकरण",
    "current_version_4.1.6": "V4.1.8",
    "notification_about_network_security": "नेटवर्क सुरक्षा के बारे में सूचना",
    "got_it": "समझ गया",
    "please_authenticate_for_account_safety": "आपके खाते की सुरक्षा के लिए कृपया पहचान सत्यापित करें",
    "enter_account": "कृपया खाता दर्ज करें",
    "enter_password": "कृपया पासवर्ड दर्ज करें",
    "verification_code": "सत्यापन कोड",
    "none": "कोई नहीं",
    "personal_center": "व्यक्तिगत केंद्र",
    "remote_control": "रिमोट कंट्रोल",
    "refresh_success": "रीफ्रेश सफल!",
    "logout": "लॉग आउट",
    "confirm_logout": "क्या आप वास्तव में लॉग आउट करना चाहते हैं?",
    "user_status": "उपयोगकर्ता स्थिति",
    "customer_address": "ग्राहक पता",
    "account_period": "खाता अवधि",
    "device_control": "डिवाइस रिमोट कंट्रोल",
    "clear_cache": "कैश साफ करें",
    "exit": "बाहर निकलें",
    "terminal": "टर्मिनल",
    "program": "कार्यक्रम",
    "material": "सामग्री",
    "my": "माइन",
    "display_type": "शो के प्रकार",
    "proportion": "रिज़ॉल्यूशन अनुपात",
    "resolution": "रेज़ोल्यूशन",
    "screen_orientation": "स्क्रीन की दिशा",
    "landscape": "क्षैतिज स्क्रीन",
    "portrait": "वर्टिकल स्क्रीन",
    "add_resolution": "नई रेज़ोल्यूशन जोड़ें",
    "execute_formatting_when_focus_lost": "फोकस खोने पर फॉर्मेटिंग निष्पादित करें",
    "select_resolution": "कृपया रेज़ोल्यूशन चुनें",
    "resolution_list": "रेज़ोल्यूशन सूची",
    "confirm_delete_program": "क्या आप कार्यक्रम को हटाना चाहते हैं?",
    "confirm_delete_this_program": "क्या आप वास्तव में इस कार्यक्रम को हटाना चाहते हैं?",
    "bound_tasks_exists_confirm_delete": "बाउंड कार्य हैं, क्या आप हटाना चाहते हैं?",
    "prompt": "प्रॉम्प्ट",
    "delete_failed": "हटाना विफल",
    "modification_time": "संशोधन समय",
    "resolution_": "रेज़ोल्यूशन",
    "associated_tasks": "संबंधित कार्य",
    "bound_task": "बाउंड कार्य",
    "program_management": "कार्यक्रम प्रबंधन",
    "task": "कार्य",
    "progress": "प्रगति",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "कृपया फोन नंबर दर्ज करें",
    "password": "पासवर्ड",
    "confirm_password": "पासवर्ड की पुष्टि करें",
    "enter_password_again": "कृपया पासवर्ड फिर से दर्ज करें",
    "company_name": "कंपनी का नाम",
    "enter_company_name": "कंपनी की जानकारी दर्ज करें",
    "address": "पता",
    "enter_address": "संपर्क पता दर्ज करें",
    "username_not_exist": "उपयोगकर्ता नाम मौजूद नहीं है",
    "enter_new_password": "नया पासवर्ड दर्ज करें",
    "enter_new_password_again": "नया पासवर्ड दोबारा दर्ज करें",
    "terminal_management": "टर्मिनल प्रबंधन",
    "delete_group": "समूह हटाएं",
    "pel_select_group": "कृपया समूह चुनें",
    "enter_device_name": "डिवाइस का नाम दर्ज करें",
    "delete_device": "डिवाइस हटाएं",
    "confirm_delete_device": "क्या आप इस डिवाइस को हटाना चाहते हैं?",
    "terminal_information": "टर्मिनल जानकारी",
    "qr_code_error": "QR कोड त्रुटि",
    "device_not_supported": "डिवाइस समर्थित नहीं है",
    "device_offline": "चुने गए डिवाइस को आदेश भेजने के लिए ऑनलाइन होना आवश्यक है, कृपया पुनः चयन करें!",
    "more": "और",
    "device_access": "डिवाइस एक्सेस",
    "filter": "फिल्टर",
    "all": "सभी",
    "offline": "ऑफलाइन",
    "device_name": "डिवाइस का नाम",
    "device_number": "डिवाइस नंबर",
    "device_group": "डिवाइस समूह",
    "call_device_please_wait": "डिवाइस को कॉल कर रहे हैं, कृपया प्रतीक्षा करें...",
    "create_terminal_group": "नई डिवाइस सूची समूह बनाएं",
    "enter_search_keyword": "खोज कीवर्ड दर्ज करें",
    "bind_device": "डिवाइस बाइंड करें",
    "select_device_group": "कृपया डिवाइस समूह चुनें",
    "authorized": "अधिकार प्राप्त",
    "unauthorized": "अधिकार प्राप्त नहीं",
    "adjust_volume": "वॉल्यूम सेट करें",
    "reboot_device": "डिवाइस को पुनः चालू करें",
    "wake_up": "जागृत करें",
    "sleep": "निष्क्रिय",
    "shutdown": "शट डाउन करें",
    "clean_up_timing_on_off": "समयबद्ध साफ़ करें",
    "clean_up_disk": "डिस्क साफ़ करें",
    "clean_up_task": "कार्य साफ़ करें",
    "send_command": "आदेश भेजें",
    "confirm2": "क्या आप भेजना चाहते हैं?",
    "terminal_operation": "टर्मिनल संचालन",
    "bind_task": "कार्य की जानकारीं",
    "remote_command": "दूरस्थ आदेश",
    "remote_monitor": "दूरस्थ निगरानी",
    "adding_one_will_override_the_previous": "केवल एक रिकॉर्ड जोड़ने की अनुमति है, पिछले रिकॉर्ड को ओवरराइट करेगा",
    "screenshot_in_progress_please_wait": "स्क्रीनशॉट लिया जा रहा है, कृपया प्रतीक्षा करें",
    "schedule_on_off": "पावर ऑन/ऑफ टाइमर",
    "shutdown_time": "शटडाउन समय",
    "startup_time": "स्टार्टअप समय",
    "volume_setting": "आवाज सेटिंग",
    "edit_device_name": "डिवाइस का नाम संपादित करें",
    "please_select_time": "कृपया समय चुनें",
    "device_not_online_please_retry": "डिवाइस ऑनलाइन नहीं है, कृपया पुनः प्रयास करें",
    "sent_successfully": "सफलता से भेजा गया",
    "version": "V4.1.8",
    "texta": "पाठ",
    "userName": "खाता",
    "email": "ईमेल",
    "device_memory": "डिवाइस मेमोरी",
    "device": "डिवाइस",
    "device_mac": "डिवाइस MAC",
    "screen_count": "स्क्रीन की संख्या",
    "device_location": "डिवाइस स्थान",
    "is_authorized": "क्या अधिकार प्राप्त है",
    "remark": "टिप्पणी",
    "device_ip": "डिवाइस IP",
    "system_version": "सिस्टम संस्करण",
    "playback_date": "प्लेबैक तिथि",
    "playback_period": "प्लेबैक अवधि",
    "retrieve_again": "फिर से प्राप्त करें",
    "please_enter_password": "8 अंकों से अधिक, संख्याओं, अक्षरों, विशेष वर्ण[@#$%^&+=] वाले पासवर्ड दर्ज करें!",
    "passwords_do_not_match": "दो बार दर्ज किया गया पासवर्ड मेल नहीं खाता",
    "enter_new_password2": "नया पासवर्ड दर्ज करें",
    "current_password_too_simple": "वर्तमान पासवर्ड बहुत सरल है, कृपया अपनी सुरक्षा के लिए जल्द से जल्द पासवर्ड बदलें। 8 अंकों से अधिक, संख्याओं, अक्षरों, विशेष वर्ण[@#$%^&+=] वाले पासवर्ड दर्ज करें",
    "creation_time": "निर्माण समय",
    "login2": "लॉगिन",
    "welcome": "लॉगिन में आपका स्वागत है",
    "expired_login": "प्रमाणीकरण की अवधि समाप्त हो गई है, कृपया फिर से लॉगिन करें।",
    "control": "रिमोट कंट्रोल",
    "add_task": "कार्य जोड़ें",
    "program_list": "कार्यक्रम सूची",
    "terminal_info": "टर्मिनल जानकारी",
    "add_program": "कार्यक्रम जोड़ें",
    "material_management": "सामग्री प्रबंधन",
    "change_password": "पासवर्ड बदलें",
    "enter_text_content": "पाठ सामग्री दर्ज करें",
    "hit_the_wall_on_back": "पीछे जाने पर दीवार है",
    "last_ceremony": "आखिरी समारोह",
    "already_top_level": "पहले से ही शीर्ष स्तर है",
    "already_last_one": "पहले से ही आखिरी है",
    "white_fox": "सफेद लोमड़ी",
    "control_img": "छवि",
    "control_video": "वीडियो",
    "control_streaming": "स्ट्रीमिंग",
    "control_webPage": "वेबसाइट",
    "control_subtitle": "उपशीर्षक",
    "control_HDMI": "HDMI",
    "control_addbackground": "पृष्ठभूमि",
    "Up": "अपलोड",
    "onlyOne": "कंट्रोल केवल एक ही जोड़ा जा सकता है",
    "clearBg": "पृष्ठभूमि हटाएं",
    "get_code": "पहले कृपया सत्यापन कोड दर्ज करें",
    "del_Null_Program": "क्या सूची में खाली कार्यक्रम को साफ किया जा सकता है?",
    "please_select_date": "कम से कम एक दिनांक चुनें",
    "last_size": "बचा हुआ स्थान",
    "shutdown_tips": "शटडाउन के बाद दूरस्थ रूप से चालू नहीं किया जा सकता",
    "last_size_upload": "कृपया पुनः चयन करें।",
    "end_date_earlier_than_start_date": "समाप्ति तिथि प्रारंभ तिथि से पहले नहीं हो सकती",
    "account_type": "उपयोगकर्ता प्रकार",
    "user_type": "सामान्य उपयोगकर्ता",
    "role_type": "भूमिका",
    "super_administrator": "सुपर प्रशासक",
    "term_info_empty": "टर्मिनल जानकारी खाली है",
    "select_terminal_prompt": "कृपया दाईं ओर ऊपर की सूची बटन पर क्लिक करें और टर्मिनल चुनें",
    "select": "चुनें",
    "data_empty": "डेटा खाली है!",
    "content_review": "सामग्री समीक्षा",
    "start_date": "आरंभ की तिथि",
    "end_date": "समाप्ति की तिथि",
    "start_time": "शुरू होने का समय",
    "end_time": "समाप्ति का समय",
    "select_all": "सभी चुनें",
    "select_group": "समूह चुनें",
    "review": "समीक्षा",
    "material_type": "सामग्री का प्रकार",
    "audio": "ऑडियो",
    "document": "फ़ाइल",
    "material_status": "सामग्री की स्थिति",
    "material_review": "सामग्री समीक्षा",
    "current_selection_requires_review": "वर्तमान चयनित सामग्री, क्या इसकी समीक्षा की आवश्यकता है?",
    "invCode": "निमंत्रण कोड",
    "tip_invitation_empty": "कृपया निमंत्रण कोड दर्ज करें",
    "enter_userName": "कृपया उपयोगकर्ता खाता दर्ज करें",
    "enter_email": "कृपया ईमेल दर्ज करें",
    "file_less_38": "फाइल का आकार 38KB से कम होना चाहिए",
    "viewError": "यह फ़ाइल पूर्वावलोकन का समर्थन नहीं करती है",
    "user": "व्यक्तिगत जानकारी",
    "phone_number_too_short": "मोबाइल नंबर की लंबाई 9 अंक से अधिक होनी चाहिए",
    "oneImage": "पृष्ठभूमि चित्र पहले से मौजूद है, यदि पुनः अपलोड करना हो तो पहले हटाएं",
    "del_title": "हटाने की पुष्टि",
    "del_message": "क्या आप कंट्रोल को हटाना चाहते हैं?",
    "close": "बंद करें",
    "exit_group_name": "समूह का नाम संपादित करें",
    "group_management": "समूह प्रबंधन",
    "language": "भाषा बदलें",
    "mixture": "मिक्स",
    "date": "दिनांक",
    "weeks": "सप्ताह",
    "time": "समय",
    "new_password": "नया पासवर्ड",
    "enter_invCode": "निमंत्रण कोड कृपया उच्च प्रबंधक से प्राप्त करें",
    "msg_password": "कृपया 8 अंकों से अधिक, संख्याएं, अक्षर, विशेष वर्ण[@#$%^&+=] वाला पासवर्ड दर्ज करें!",
    "oneDoc": "दस्तावेज़ पहले से मौजूद है, यदि पुनः अपलोड करना हो तो पहले हटाएं",
    "Sunday": "रविवार",
    "Monday": "सोमवार",
    "Tuesday": "मंगलवार",
    "Wednesday": "बुधवार",
    "Thursday": "गुरुवार",
    "Friday": "शुक्रवार",
    "Saturday": "शनिवार",
    "input_error": "फॉर्म के सभी फ़ील्ड खाली नहीं हो सकते",
    video_tutorial:'सामग्री',
    "view": "ऑनलाइन देखना",
    "selectDeviceOne": "इस आदेश में केवल एक उपकरण का चयन किया जा सकता है",
    "select_device_list": "चुने गए उपकरणों की सूची",
    "small_size": "छोटा",
    "medium_size": "मध्यम",
    "large_size": "बड़ा",
    device_info:'उपकरण जानकारी',
    "notification": "सूचना",
    "notif_title": "सूचना सामग्री",
    "notif_msg": "5 नवंबर 2024 से, ETV सेवा केंद्र एक वर्ष से अधिक समय से संग्रहीत सामग्री को हटा देगा। कृपया ध्यान दें और महत्वपूर्ण सामग्री का पूर्व में बैकअप लें। आपकी समझ और सहयोग के लिए धन्यवाद।",
    reduce: 'घटाना',
    bound_material: 'बंधित सामग्री',
    tip_material: 'बंधित कार्यक्रम की सामग्री को हटाया नहीं जा सकता, कृपया पहले सामग्री को अनबाइंड करें।',
    boundpo: 'बंधित कार्यक्रम',
    bind_progron: 'यह सामग्री एक कार्यक्रम से बंधी हुई है, इसे हटाया नहीं जा सकता।',
    index: 'अनुक्रमांक',
    source: 'स्रोत',
    getUploadSet_tip: 'सामग्री अपलोड निषेध प्राप्त करने में विफल।',
    getUploadstartTime_tip: 'वर्तमान समय में सामग्री अपलोड करना निषेधित है, कृपया निषेधित समय के बाहर अपलोड करें।',
    getUploadendTim: 'सामग्री अपलोड निषेधित।',
    "download": "डाउनलोड",
    program_review: 'कार्यक्रम समीक्षा',
    pass: 'पास',
    not_passed_or_not_reviewed: 'पास नहीं हुआ या समीक्षा नहीं हुई',
    play_mode: 'प्ले मोड',
    review_status: 'समीक्षा स्थिति',
    reject: 'अस्वीकार',
    review_content: 'समीक्षा सामग्री',
    enter_review_content: 'कृपया समीक्षा सामग्री दर्ज करें',
    device_quantity: "उपकरणों की संख्या",
    system_help: 'सिस्टम सहायता',
    updateInfo: 'अपडेट जानकारी',
    Formatspecification: 'प्रारूप विनिर्देश',
    fileFormat: 'फ़ाइल प्रारूप',
    imgFormat: 'छवि प्रारूप',
    audioFormat: 'ऑडियो प्रारूप',
    videoFormat: 'वीडियो प्रारूप',
    updated: 'अपडेट की तारीख',
    details: '1: मेरा - सिस्टम सहायता मेनू जोड़ा गया<br>2: नए अपलोड सामग्री प्रकार, Tencent क्लाउड अपलोड, पीसी सेटिंग्स के साथ सिंक जोड़ा<br>3: सामग्री और कार्यक्रम सामग्री प्रदर्शन का अनुकूलन',
    "nameLengthLimit": "कृपया नाम की लंबाई को 50 वर्णों तक सीमित करें।",
    "customer_title": "खाता जांच",
    "authorized_devices": "अधिकृत उपकरण",
    "enable": "सक्षम करें",
    "disable": "अक्षम करें",
    "expired": "खाता समाप्त",
    "valid_date": "मान्य तिथि",
    "valid_date_placeholder": "मान्य तिथि दर्ज करें",
    "capacity_rule": "सर्वर क्षमता 100 का गुणक होना चाहिए",
    "capacity_label": "सर्वर क्षमता (MB)",
    "download_speed": "डाउनलोड गति सीमा ",
    "submit_btn": "जमा करें",
    sub_accounts: 'केवल उप-खाता संशोधन समर्थित है',
    plan_mode: 'योजना मोड',
    default_mode: 'डिफ़ॉल्ट मोड',

  },
  vanDialog: {
    confirm: 'पुष्टि करें',
    cancel: 'रद्द करें'
  },
  vanPicker: {
    confirm: 'पुष्टि करें',
    cancel: 'रद्द करें',
  },
  vanDatetimePicker: {
    title: 'तारीख चुनें',
  },
}